import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(5),
      justifyContent: 'center',
      paddingLeft: spacing(3),
      paddingRight: spacing(3),
      paddingBottom: spacing(10),
      height: '100%',
      boxSizing: 'border-box',
    },
    contentContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
      justifyContent: 'center',
    },
    iconSection: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      justifyContent: 'center',
    },
    textSection: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      justifyContent: 'center',
      maxWidth: 500,
    },
    mainMessage: {
      color: colours.neutral[900],
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '28px',
      margin: 0,
      textAlign: 'center',
    },
    secondaryMessage: {
      color: colours.neutral[600],
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      margin: 0,
      textAlign: 'center',
    },
    buttonRow: {
      alignItems: 'flex-start',
      display: 'flex',
      gap: spacing(3),
      justifyContent: 'flex-start',
    },
    returnButton: {
      minWidth: 'auto',
    },
    updateNotice: {
      alignItems: 'center',
      display: 'flex',
      gap: spacing(1),
      justifyContent: 'center',
      backgroundColor: colours.brandLilac[50],
      borderRadius: 8,
      padding: spacing(2, 4),
    },
    updateNoticeIcon: {
      width: 16,
      height: 16,
    },
    updateNoticeText: {
      color: colours.brandLilac[700],
      fontSize: 14,
      fontWeight: 400,
      margin: 0,
    },
  });
